import { FC } from 'react'
import { Dashboard } from './dashboard.tsx'
import { MainContent } from '../../components/main-content.tsx'
import { MainContentHeader } from '../../components/main-content-header.tsx'
import { MainContentBody } from '../../components/main-content-body.tsx'
import { Layout } from '../../components/layout.tsx'

export const DashboardPage: FC = () => {
  return (
    <Layout>
      <MainContent>
        <MainContentHeader
          breadcrumbs={[{ label: 'Dashboard', href: '/dashboard' }]}
          title="Dashboard"
        />
        <MainContentBody>
          <Dashboard />
        </MainContentBody>
      </MainContent>
    </Layout>
  )
}
